import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.string.match-all.js";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/esm/setPrototypeOf";
const _excluded = ["transformations"],
  _excluded2 = ["width", "height", "f"];
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.string.match-all.js";
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = new RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}
import { toUrl } from "../utils.js";
const cloudflareRegex = /*#__PURE__*/_wrapRegExp(/https?:\/\/([^\/]+)\/cdn\x2Dcgi\/image\/([^\/]+)?\/(.*)$/g, {
  host: 1,
  transformations: 2,
  path: 3
});
const parseTransforms = transformations => Object.fromEntries(transformations.split(",").map(t => t.split("=")));
const formatUrl = _ref => {
  let {
    host,
    transformations = {},
    path
  } = _ref;
  const transformString = Object.entries(transformations).map(_ref2 => {
    let [key, value] = _ref2;
    return key + "=" + value;
  }).join(",");
  const pathSegments = [host, "cdn-cgi", "image", transformString, path].join("/");
  return "https://" + pathSegments;
};
export const parse = imageUrl => {
  const url = toUrl(imageUrl);
  const matches = _toConsumableArray(url.toString().matchAll(cloudflareRegex));
  if (!matches.length) {
    throw new Error("Invalid Cloudflare URL");
  }
  const group = matches[0].groups || {};
  const {
      transformations: transformString
    } = group,
    baseParams = _objectWithoutPropertiesLoose(group, _excluded);
  const _parseTransforms = parseTransforms(transformString),
    {
      width,
      height,
      f
    } = _parseTransforms,
    transformations = _objectWithoutPropertiesLoose(_parseTransforms, _excluded2);
  const base = formatUrl(Object.assign({}, baseParams, {
    transformations
  }));
  return {
    base: url.toString(),
    width: Number(width) || undefined,
    height: Number(height) || undefined,
    format: f,
    cdn: "cloudflare",
    params: Object.assign({}, group, {
      transformations
    })
  };
};
export const generate = _ref3 => {
  var _props$transformation;
  let {
    base,
    width,
    height,
    format,
    params
  } = _ref3;
  const parsed = parse(base.toString());
  const props = Object.assign({
    transformations: {}
  }, parsed.params, params);
  if (width) {
    props.transformations.width = width === null || width === void 0 ? void 0 : width.toString();
  }
  if (height) {
    props.transformations.height = height === null || height === void 0 ? void 0 : height.toString();
  }
  if (format) {
    props.transformations.f = format === "jpg" ? "jpeg" : format;
  }
  (_props$transformation = props.transformations).fit || (_props$transformation.fit = "cover");
  return new URL(formatUrl(props));
};
export const transform = _ref4 => {
  let {
    url: originalUrl,
    width,
    height,
    format = "auto"
  } = _ref4;
  const parsed = parse(originalUrl);
  if (!parsed) {
    throw new Error("Invalid Cloudflare URL");
  }
  const props = Object.assign({}, parsed, {
    width,
    height,
    format
  });
  return generate(props);
};